module.exports = __webpack_public_path__ + "img/logo.6f3f5acc.svg";